const o = "_code_1qh2x_1", t = "_noWrap_1qh2x_16", _ = "_fullWidth_1qh2x_20", l = {
  code: o,
  noWrap: t,
  fullWidth: _
};
export {
  o as code,
  l as default,
  _ as fullWidth,
  t as noWrap
};
//# sourceMappingURL=Code.module.css.js.map
